{
    "email_templates": {
        "do_not_send": "Don't send this email"
    },
    "email_templates_editor": {
        "category": "Category",
        "copy_template_to_clipboard": "Copy template",
        "email_type": {
            "label": "Email type",
            "more_info_link": "Learn more about email types"
        },
        "label": "Email editor",
        "merge_tags": {
            "meeting": {
                "attendee_details": "Attendee details",
                "attendee_note": "Attendee note",
                "attendee_status": "Attendee status",
                "date": "Date",
                "description": "Description",
                "location": "Location",
                "meeting_bstg_url": "Meeting Backstage URL",
                "meeting_participants_with_status": "Meeting participants with status list",
                "meetings_daily_date": "Reminder today's date",
                "meetings_daily_summary": "Meetings daily summary",
                "organizer": "Organizer",
                "organizer_email": "Organizer's email",
                "organizer_fname": "Organizer's first name",
                "organizer_lname": "Organizer's last name",
                "participant_count": "Participants count",
                "section_name": "Meeting details",
                "status": "Status",
                "time": "Time",
                "title": "Title"
            },
            "meeting_location_fields": {
                "section_name": "Meeting location details"
            },
            "session": {
                "lease_time": "Available claim time",
                "section_name": "Session details",
                "waitlisted_session": "Waitlisted session name"
            },
            "workspace": {
                "calendar_invite": "Calendar invite title",
                "categories": "Categories",
                "country": "Country",
                "country_code": "Country code",
                "end_date": "End date",
                "event_name": "Event name",
                "id": "Workspace ID",
                "in_app_display": "In-app display name",
                "location": "Location",
                "organization_name": "Organization name",
                "section_name": "Event details",
                "start_date": "Start date",
                "timezone": "Timezone"
            }
        },
        "messages": {
            "not_loaded": "Could not load the template editor. Please try again later.",
            "not_uploaded": "Could not upload the asset. Please try again later."
        },
        "metadata_error": "Please try again later. If the problem persists contact the support.",
        "mode_switch_btn_label_off": "Use my own HTML code",
        "mode_switch_btn_label_on": "Use design editor",
        "paste_template_from_clipboard": "Paste template",
        "save_error": "Email template could not be saved.",
        "save_success": "Email template has been saved.",
        "subject": "The email subject should be no more than 60 characters or 10 words, in order to display properly on mobile and on all email providers.",
        "template_error": "Could not load the template at this moment. Try again later. If the problem persists please contact the support.",
        "validation": {
            "email_multiple_validation_errors": "Multiple issues with your email template",
            "email_skippable_error_go_back": "Back to editing",
            "promotional_error_save_anyway": "Save without link",
            "promotional_error_text": "This email is classified as <strong>Promotional</strong>, therefore an unsubscribe link is required. We recommend adding it to allow participants to indicate their communication preferences. You can use our footer templates in the 'blocks' section in the email editor.",
            "promotional_error_title": "No unsubscribe link detected",
            "save_anyway": "Save anyway",
            "tiny_link_error_qr_title": "QR code contains shortened links",
            "tiny_link_error_text": "Shortened links may contain personal access links. Ensure that this isn't the case.<br/> <a href='{0}' target='_blank'>Learn more about personal access links.</a>",
            "tiny_link_error_title": "Detected shortened links",
            "token_error_qr_title": "QR code contains personal access links",
            "token_error_text": "Personal access links should be shared only with the users for whom they were intended. Use the platform's special link instead.<br/> <a href='{0}' target='_blank'>Learn more about personal access links.</a>",
            "token_error_title": "Detected personal access links",
            "transactional_error_save_anyway": "Save and keep link",
            "transactional_error_text": "This email is classified as <strong>Transactional</strong>, therefore an unsubscribe link is not required. We recommend removing it to ensure essential information can be sent to your event attendees. You can use our footer templates in the 'blocks' section in the email editor.",
            "transactional_error_title": "Unsubscribe link detected",
            "undefined_type_error_save_anyway": "Save as Undefined",
            "undefined_type_error_text": "We recommend classifying either of the email types below:<br><ul><li><strong>Transactional</strong>: Essential event information.</li><li><strong>Promotional</strong>: Non-essential event information.</li></ul><a href='{0}'>Learn more about email types.</a>",
            "undefined_type_error_title": "This email is currently marked as 'Undefined'"
        }
    },
    "emailing": {
        "actions": {
            "send_email": "Send email",
            "send_email_placeholder": "Send an email",
            "send_email_unsubscribed_warning": "This user is unsubscribed, so they can only receive emails classified as 'Transactional'.<br><a href='{0}'>Learn more about email types</a>"
        },
        "list": {
            "headers": {
                "clicks": "Clicks",
                "open": "Opens",
                "recipients": "Recipients",
                "sent_at": "Sent",
                "status": "Status",
                "template": "Template",
                "to": "To"
            }
        },
        "logs": {
            "alert": {
                "message": "Please be careful when sharing email log details, as they may include information that is unique to users and their accounts, including their personal access link to provide meeting availability."
            },
            "analytics": "Analytics",
            "compile_failed": "This email template could not be interpolated, so the preview below shows the raw template with its placeholders.",
            "headers": {
                "clicked": "Clicked:",
                "clicks": "Clicks",
                "last_clicked": "Last clicked:",
                "last_opened": "Last opened:",
                "name": "Name",
                "opened": "Opened:",
                "opens": "Opens",
                "queued": "Queued",
                "send_timestamp": "Attempt",
                "status": "Status",
                "subject": "Subject",
                "to": "Email"
            },
            "log_html": "Email preview",
            "messages": {
                "occurrences": "Never|Once|{0} times"
            },
            "open_in_editor": "Open in editor",
            "overview": "Overview",
            "preview": "Show email",
            "reports": "Reports",
            "smtp_events": "SMTP events",
            "status_groups": {
                "all": "All",
                "bounced": "Bounced",
                "delivered": "Delivered",
                "other": "Other",
                "processing": "Processing",
                "rejected": "Rejected",
                "unsubscribed": "Unsubscribed"
            }
        },
        "mailing": {
            "details": {
                "headers": {
                    "progress": "Progress",
                    "scheduled_at": "Scheduled at",
                    "status": "Status",
                    "template": "Template"
                },
                "no_address": "Skipped due to empty email address",
                "no_doc": "Skipped due to missing document record",
                "processed": "Processed (both skipped and successfully delivered)",
                "title": "Recipients",
                "unsubscribed": "Skipped due to being unsubscribed"
            }
        },
        "messages": {
            "edit_disabled": "This email is about to be sent and can no longer be edited.",
            "load_failed": "Could not load the list of scheduled emails. Please try again later.",
            "prompt_delete": "Are you sure you want to cancel this mailing?",
            "recipients_info": "Number of users currently matching the targeting rule. Final recipients will be determined before sending."
        },
        "statuses": {
            "cancelled": "Cancelled",
            "failed": "Failed",
            "scheduled": "Scheduled",
            "sending": "Sending",
            "sent": "Sent"
        },
        "targeting": {
            "intro": "Choose who is going to receive the email.",
            "label": "Custom targeting",
            "text_for_hidden_to": "This will not be sent to attendees who match the below rule(s).",
            "text_for_visible_to": "This will be sent to attendees who match the below rule(s).",
            "will_send_to": "No Recipients"
        },
        "targets": {
            "active": "Active users",
            "all": "All users",
            "cancelled": "Cancelled",
            "everyone": "Everyone",
            "inactive": "Inactive users",
            "not-invited": "Not invited",
            "pending": "Invited, not activated users",
            "rsvp-not-invited": "RSVP - not invited",
            "selected": "Selected users",
            "self-reg-unverified-email": "Registered, not activated",
            "targeted": "Targeted users"
        }
    }
}
